import * as React from 'react'
import { Header, Loader } from 'semantic-ui-react'
import HelperTextLabel from '../HelperTextLabel'
import styles from './styles.module.less'

export interface CalculationDetailProps {
  label: string
  value: string
  helperText?: string
  loading?: boolean
}

const CalculationDetail = ({ label, value, helperText, loading }: CalculationDetailProps) => {
  return (
    <div className={styles.calculationDetail}>
      <Header as={'h4'} className={styles.calulationDetailLabel}>
        <HelperTextLabel label={label} helperText={helperText} />
      </Header>
      {loading ? (
        <Loader size={'small'} inline active />
      ) : (
        <div className={`${styles.calulationDetailValue} test-calculation-detail-value`}>{value}</div>
      )}
    </div>
  )
}

export default CalculationDetail
